import { render, staticRenderFns } from "./noAuthority.vue?vue&type=template&id=61017bcd&scoped=true"
import script from "./noAuthority.vue?vue&type=script&lang=js"
export * from "./noAuthority.vue?vue&type=script&lang=js"
import style0 from "./noAuthority.vue?vue&type=style&index=0&id=61017bcd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61017bcd",
  null
  
)

export default component.exports